import React from 'react';

import ChevronRightSolidIcon from '../../../../shared/icons/chevron-right-solid-icon';
import Button from '../../../button/button';
import Typography from '../../../typography/typography';

import './fitment-shop-by-button.scss';

interface FitmentShopByButtonProps {
  icon: React.ElementType;
  onClick: (tab: string) => void;
  tab: string;
}

function FitmentShopByButton(props: FitmentShopByButtonProps) {
  const { icon: Icon, onClick, tab } = props;

  return (
    <Button onClick={() => onClick(tab)} styleName="container">
      <Icon styleName="icon" />
      <Typography weight="black">Shop by {tab}</Typography>
      <ChevronRightSolidIcon styleName="chevron" />
    </Button>
  );
}

export default FitmentShopByButton;
